let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1vipW")).then(() => parcelRequire('dZbks'));